import { ComponentService } from "../Services/Axios/Api";

class RichTextEditor {
    data = {};
    constructor() {
        this.data = {
            id: '',
            ComponentName: 'RichText',
            content: {
                html: '<p>Welcome to the Rich Text Editor</p>',
                delta: JSON.stringify({
                    ops: [
                        { insert: 'Welcome to the Rich Text Editor\n' }
                    ]
                })
            },
            settings: {
                toolbar: [
                    ['bold', 'italic', 'underline', 'strike'],
                    ['blockquote', 'code-block'],
                    [{ 'header': 1 }, { 'header': 2 }],
                    [{ 'list': 'ordered'}, { 'list': 'bullet' }],
                    [{ 'script': 'sub'}, { 'script': 'super' }],
                    [{ 'indent': '-1'}, { 'indent': '+1' }],
                    [{ 'direction': 'rtl' }],
                    [{ 'size': ['small', false, 'large', 'huge'] }],
                    [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
                    [{ 'color': [] }, { 'background': [] }],
                    [{ 'font': [] }],
                    [{ 'align': [] }],
                    ['clean'],
                    ['link', 'image', 'video']
                ],
                theme: 'snow',
                placeholder: 'Write something...',
                readOnly: false
            }
        };
    }

    // Id
    getId() { return this.data.id; }
    setId(id) { this.data.id = id; }

    // Name
    getComponentName() { return this.data.ComponentName; }
    setComponentName(ComponentName) { this.data.ComponentName = ComponentName; }

    // Content
    getContent() { return this.data.content; }
    setContent(content) { this.data.content = content; }

    // Settings
    getSettings() { return this.data.settings; }
    setSettings(settings) { this.data.settings = settings; }

    // Data
    getData() { return this.data; }
    setData(data) { this.data = data; }

    // Methods
    async load(id) {
        try {
            var response = {};
            var data = {};
            if (id) {
                response = await ComponentService.getComponentById(id);
                data = response.data ? JSON.parse(response.data) : {};
                this.setId(response?.id);
            } else {
                response = await ComponentService.getComponent(this.data.ComponentName);
                data = JSON.parse(response[0]?.data);
                this.setId(response[0]?.id);
            }
            
            if(Object.keys(data).length > 0) {
                this.setData(data);
                this.setContent(data.content);
                this.setSettings(data.settings);
            }
            return data;
        } catch (error) {
            throw new Error(error.response.data);
        }
    }

    async save() {
        try {
            const response = await ComponentService.SaveData(this.getId(), this.getData());
            return response;
        } catch (error) {
            throw new Error(error.response.data);
        }
    }

    // Helper methods for content manipulation
    getHTML() {
        return this.data.content.html;
    }

    getDelta() {
        return JSON.parse(this.data.content.delta);
    }

    setHTML(html) {
        this.data.content.html = html;
    }

    setDelta(delta) {
        this.data.content.delta = JSON.stringify(delta);
    }
}

export const createRichTextEditorInstance = () => new RichTextEditor();
